<template>
  <div class="canvas">
    <div class="biaoti">访客自行填写转发码</div>
    <button @click="generateQrCode">点击生成小程序码</button>
    <p class="explanation">解释：生成的小程序码自带个人的信息，访客直接通过微信扫码进入小程序直接填写表单即可</p>
    <div class="qr-code">
      <img v-if="qrCodeBase64" :src=" qrCodeBase64" alt="小程序码">
    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {
      qrCodeBase64: null // 用于存储Base64编码的二维码字符串
    };
  },
  methods: {
    async generateQrCode() {
      try {
        // 从后端获取Base64编码的二维码字符串
        const response = await this.$axios.get('/api/getXCXQrCode');
        this.qrCodeBase64 = response.data;
        // console.log(this.qrCodeBase64);
        // console.log('qrCodeBase64', this.qrCodeBase64);
      } catch (error) {
        console.error('Error fetching QR code:', error);
      }
    }
  }
};
</script>

<style scoped>
body {
  background-color: #f7f8fa; /* 设置背景为灰色 */
}
.canvas {
  background-color: white; /* 设置画布为白色 */
  padding: 20px;
  border-radius: 10px; /* 可以根据需要调整画布的圆角 */
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2); /* 给画布添加阴影效果 */
  width: 97%; /* 根据需要调整画布宽度 */
  position: relative;
}
button {
  padding: 10px 20px;
  margin: 5px;
  border: none;
  border-radius: 5px;
  background-color: #007bff;
  color: white;
  cursor: pointer;
}

button:hover {
  background-color: #0056b3;
}

.explanation {
  color: #666;
  font-size: 14px;
  margin: 10px 10px;
}

.qr-code {
  margin: 20px 0;
}

.qr-code canvas {
  width: 150px;
  height: 150px;
}
.biaoti {
  font-family: 'Georgia', serif;
  color: #4396e5;
  font-size: 30px;
  font-weight: bold;
  padding: 15px;
}
</style>